'use es6';

import styled from 'foundations-theming/utils';
import UIButton from 'UIComponents/button/UIButton';
export default styled(UIButton).withConfig({
  displayName: "StyleProtectedTransparentButton",
  componentId: "sc-19p39eg-0"
})(["color:", " !important;background-color:transparent !important;padding-left:5px !important;padding-right:5px !important;font-size:13px !important;margin-bottom:1px !important;"], ({
  theme
}) => theme.color['do-not-use-calypso-dark']);